<template>
  <transition name="modal-fade">
    <div v-if="showDialog" class="modal-base">
      <div class="modal-base__backdrop" @click="closeModal()" />
      <div
        class="modal-base__dialog text-size-14"
        :style="cssStyle"
        style="margin: 150px auto; max-height: 80%;"
      >
        <div class="modal-base__body">
          <div
            class="k-row display-flex align-items-center mb-3"
            v-for="participant in participantsList"
            :key="participant.id"
          >
            <div
              class="align-items-center user-details"
              style="width: 85%; display: flex;"
            >
              <div class="k-participant-icon">
                <font-awesome-icon size="xs" :icon="['fas', 'user-circle']" />
              </div>
              <div class="k-participant-details justify-content-start ml-2">
                <div class="k-participant-name text-standard">
                  {{ participant.name }}
                </div>
                <div
                  v-if="isOwner"
                  class="k-participant-email text-very-small text-weight-light"
                >
                  <div class="k-email">
                    {{ participant.email }}
                  </div>
                </div>
              </div>
            </div>
            <div class="actions">
              <template v-if="participant.choice != -1 && participant.choice < 2">
                <div class="d-flex" :class="{'km-accepted': participant.choice >= 1}">
                  <span class="icon-style"
                    > <font-awesome-icon
                      class="fa-align-center"
                      :icon="getIconFromAnswer(participant.choice)"
                      aria-hidden="true"
                  /></span>
                </div>
              </template>
              <template v-else-if="participant.choice == 2">
                <div class="d-flex km-accepted">
                  <span class="icon-style font-20"
                    >(<font-awesome-icon
                      class="fa-align-center"
                      :icon="['fas', 'check']"
                      aria-hidden="true"
                    />)</span
                  >
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalParticipantInfoDialog',
  props: ['participants', 'isOwner'],

  data() {
    return {
      showDialog: false,
      xPos: null,
      yPos: null,
      sortedParticipants: null
    };
    
  },
  computed: {
    mobileView() {
      return this.$store.state.mobileView;
    },
    cssStyle() {
      if (this.width) {
        const width = this.width;
        return `width:${width}px;`;
      }
      if (this.mobileView) return '';
      return 'max-width:600px;';
    },
    participantsList(){
      return this.sortedParticipants;
    }
  },

  methods: {
    openModal(event) {
      if (event) {
        this.xPos = event.clientX;
        this.yPos = event.clientY;
      }
      // sort the list of users
      console.info("sorted participant:", this.participants);      
      this.sortedParticipants = this.participants.sort((p1, p2) => {
        let  p1Choice = p1.choice;
        if( p1Choice == 2 ) {
          p1Choice = 1;
        } else if( p1Choice == 1) {
          p1Choice = 2;
        } else if( p1Choice == -1) {
          // not answered choices
          p1Choice = -3;
        }

        let  p2Choice = p2.choice;
        if( p2Choice == 2 ) {
          p2Choice = 1;
        } else if( p2Choice == 1) {
          p2Choice = 2;
        } else if( p2Choice == -1) {
          // not answered choices
          p2Choice = -3;
        }

        if (p1Choice > p2Choice) return -1;
        if (p1Choice < p2Choice) return 1;
        return 0;
      });
      console.info("Sortedparticipant:", this.sortedParticipants);
      this.showDialog = true;
    },
    closeModal() {
      //$emit('cancel')
      this.showDialog = false;
    },
    getIconFromAnswer(answer) {
      let icon = "";
      if(answer == -2) {
        icon = ['fas', 'question'];
      } else if(answer == 0) {
        icon = ['fas', 'times'];
      } else if(answer == 1) {
        icon = ['fas', 'check'];
      }
      return icon;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/style.scss';

.modal-base {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  color: $dark-grey;
  &__backdrop {
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
  &__dialog {
    background-color: $white;
    position: relative;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    z-index: 2;
    max-width: 600px;
    border: 1px solid $mid-grey;
    -webkit-transform: translate3d(0, 0, 0);
    @media screen and (max-width: 767px) {
      width: 90%;
    }
  }
  &__close {
    width: 30px;
    height: 30px;
  }
  &__header {
    padding: 20px 20px 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    font-size: $big-extra;
    @media screen and (max-width: 480px) {
      font-size: $standard;
    }
  }
  &__body {
    padding: 10px 20px 10px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  &__footer {
    margin: 10px;
    margin-top: 0px;
    padding-top: 10px;
    border-top: 0px solid $light-grey;
  }
}

.modal-fade-enter-active {
  transition: opacity 0.5s;
}

.modal-fade-leave-active {
  transition: opacity 0.5s;
}

.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter {
  opacity: 0;
}

.k-participant-icon {
  line-height: 1.5;
}

@media screen and (max-width: 480px) {
  .k-participant-icon {
    display: contents;
    svg {
      font-size: $large;
    }
  }
}

.km-accepted {
  color: $checked-color;
}

.actions {
  font-size: $large;
  width: 15%;
  .icon-style {
    width: 100%;
    text-align-last: center;
  }
}

.display-flex {
  display: flex;
  justify-content: space-between;
}
</style>
